import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router';

function AggregatorsQuickAccessForm() {
  const navigate = useNavigate();

  return (
    <Form.Control
      className="bo-input bo-w-120"
      name="quickAccess"
      id="quickAccess"
      placeholder="Aggregator ID"
      noValidate
      onKeyDown={e => {
        if (e.code === 'Enter' && e.target.value !== '') {
          navigate(`/aggregator/${e.target.value}`);
        }
      }}
    />
  );
}

export default AggregatorsQuickAccessForm;
